const sidebarLinks = [
  { name: "Home", path: "/" },
  { name: "Products", path: "/products" },
];

export default sidebarLinks;
